import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AlertPopupService {

  baseUrl: string;
  idPartecipant: string;

  constructor(
    private http: HttpClient,
    private auth: AuthService
  ) {
    this.baseUrl = '';
    this.idPartecipant = '';
  }

  setBaseUrl(url: string) {
    this.baseUrl = url;
  }

  setIdPartecipant(id: string) {
    this.idPartecipant = id;
  }

  private buildUrl(path: string): string {
    return this.baseUrl + 'webApp/alert/' + path + '?idPartecipant=' + this.idPartecipant;
  }

  async getActiveAlert(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        let options = { headers: <HttpHeaders>(await this.getHeader()) };
        this.http.get(this.buildUrl('active'), options).subscribe(
          (res: any) => { resolve(res); },
          (err: any) => { reject(err); }
        );
      } catch (err) { reject(err); }
    });
  }

  async trackImpression(id_alert: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        let options = { headers: <HttpHeaders>(await this.getHeader()) };
        this.http.post(this.buildUrl('tracking/impression'), { id_alert }, options).subscribe(
          (res: any) => { resolve(res); },
          (err: any) => { reject(err); }
        );
      } catch (err) { reject(err); }
    });
  }

  async trackDismiss(id_alert: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        let options = { headers: <HttpHeaders>(await this.getHeader()) };
        this.http.post(this.buildUrl('tracking/dismiss'), { id_alert }, options).subscribe(
          (res: any) => { resolve(res); },
          (err: any) => { reject(err); }
        );
      } catch (err) { reject(err); }
    });
  }

  async trackCtaClick(id_alert: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        let options = { headers: <HttpHeaders>(await this.getHeader()) };
        this.http.post(this.buildUrl('tracking/cta_click'), { id_alert }, options).subscribe(
          (res: any) => { resolve(res); },
          (err: any) => { reject(err); }
        );
      } catch (err) { reject(err); }
    });
  }

  async trackCtaSubmit(id_alert: string, cta_type: string, payload: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        let options = { headers: <HttpHeaders>(await this.getHeader()) };
        this.http.post(this.buildUrl('tracking/cta_submit'), { id_alert, cta_type, payload }, options).subscribe(
          (res: any) => { resolve(res); },
          (err: any) => { reject(err); }
        );
      } catch (err) { reject(err); }
    });
  }

  /**
   * Genera header di autenticazione con lo stesso pattern di ApiService:
   * Authorization: Basic btoa(email:firebaseToken)
   */
  private getHeader(): Promise<HttpHeaders> {
    return new Promise((resolve, reject) => {
      if (!AuthService.authTokenInUrl) {
        this.auth.getIdToken().then((token: string) => {
          const email = AuthService.getEmail();
          return resolve(
            new HttpHeaders().set('Authorization', 'Basic ' + btoa(email + ':' + token))
          );
        }).catch((err: any) => {
          return reject(err);
        });
      } else {
        return resolve(
          new HttpHeaders().set('authToken', AuthService.authTokenInUrl)
        );
      }
    });
  }
}
